import { FormattedMessage } from '@futrli/localisation';
import React from 'react';

export const UIDefaultErrorMessage = () => (
  <FormattedMessage id="common.oops_something_went_wrong" defaultMessage="Oops, something went wrong!" />
);
